import {classNames, layout, View} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import bookIcon from "./book.svg";/**/
import {MainButton} from "./MainButton";
import openIcon from "./open.svg";
import {useLocalization} from "../../i18n";

interface BookingHomeProps {
    onBook: () => void;
    onOpen: () => void;
    siteName?: string;
    className?: string;
}

export function BookingHome({onBook, onOpen, siteName, className}: BookingHomeProps) {
    const {t} = useLocalization();

    return (
        <View className={classNames(layout.vertical, styles.noBg, className)}>
            <div className={classNames(layout.fill, layout.horizontal, layout.center, layout.alignCenter)}>
                <MainButton label={t("BookingHomeBook")} iconSrc={bookIcon} onClick={onBook} className={styles.button}/>
                <MainButton label={t("BookingHomeOpen")} iconSrc={openIcon} onClick={onOpen} className={styles.button}/>
            </div>
            {siteName && (
                <div className={styles.siteName}>
                    {siteName}
                </div>
            )}
        </View>
    );
}

const styles = stylesheet({
    noBg: {
        background: "none",
    },
    button: {
        width: "16rem",
        margin: "0 3rem",
    },
    siteName: {
        position: "absolute",
        right: 0,
        top: "1.5em",
        background: "rgba(64, 64, 64, 0.67)",
        padding: "0.5em 3em 0.5em 1em",
        fontSize: "1.25rem"
    },
})